import { useMutation } from "react-query";
import { employeesService } from "@services/employee-service";

export const useDownloadEmployeeReferralMutation = () => {
  return useMutation(employeesService.downloadEmployeeReferral);
};
